import styled from "@emotion/styled";
import { Card } from "../card/Card";

export const CardContainer = styled(Card)`
  border: 1px solid var(--color-gray-200);
  background-color: #ffffff;
  box-shadow: 11px 10px 6px rgba(37, 46, 55, 0.01), 6px 6px 5px rgba(37, 46, 55, 0.02),
    3px 3px 4px rgba(37, 46, 55, 0.03), 1px 1px 2px rgba(37, 46, 55, 0.04), 0px 0px 0px rgba(37, 46, 55, 0.04);
`;
